import styles from "styles.module.css";
import { useTranslation } from "react-i18next";
import CustomButton from "ui/Button";
import { useNavigate } from "react-router";

const AccessDenied = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();

	return (
		<div
			className={styles.PageContainer}
			style={{
				textAlign: "center",
				paddingTop: "50px",
				height: "calc(100vh -200px)",
				paddingBottom: "10%",
			}}
		>
			<div style={{}} className="">
				<legend
					className={styles.BoxHeadingLarge}
					style={{ paddingBottom: "20px", textAlign: "center" }}
				>
					{t("AccessDenied")}
				</legend>
			</div>
			<div style={{ paddingTop: "5%" }} className="">
				{/* <h1>{t("AccessDenied")}</h1> */}
				<h4>{t("AccessDeniedDescription")}</h4>

				<h4>{t("AccessDeniedAction")}</h4>
			</div>

			<div style={{ paddingTop: "5%" }} className="">
				<CustomButton
					label={t("GoBack")}
					onClick={() => {
						navigate("/", { replace: true });
					}}
				/>
			</div>
		</div>
	);
};

export default AccessDenied;
